import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const FolderClosed24 = ({
  height = 24,
  width = 24,
  color = colors.iconFolder,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18.4286 7.49999H11.7287L10.0573 4.60713C10.0009 4.50941 9.91971 4.42826 9.82199 4.37184C9.72427 4.31541 9.61341 4.28571 9.50057 4.28571H5.57143C4.88944 4.28571 4.23539 4.55662 3.75315 5.03886C3.27092 5.5211 3 6.17515 3 6.85713L3 17.1428C3 17.8248 3.27092 18.4789 3.75315 18.9611C4.23539 19.4434 4.88944 19.7143 5.57143 19.7143H18.4286C19.1106 19.7143 19.7646 19.4434 20.2468 18.9611C20.7291 18.4789 21 17.8248 21 17.1428V10.0714C21 9.38943 20.7291 8.73538 20.2468 8.25314C19.7646 7.77091 19.1106 7.49999 18.4286 7.49999Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
